import React, { useContext, useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { AppBar, Toolbar, IconButton } from '@mui/material';
import InputIcon from '@mui/icons-material/Input';
import { AppContext } from '@/AppContext';
import MeetupSelector from '../MeetupSelector/MeetupSelector';
import GearMenu from '../GearMenu/GearMenu';
import { useTheme } from '@mui/material/styles';
import { AccountCircle } from '@mui/icons-material';
import { Notifications } from '@/components/Notifications/Notifications';
import Time from './components/Time';

const PREFIX = 'Topbar';

const classes = {
  root: `${PREFIX}-root`,
  flexGrow: `${PREFIX}-flexGrow`,
  topBarIcon: `${PREFIX}-topBarIcon`,
  logo: `${PREFIX}-logo`,
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  [`&.${classes.root}`]: {
    boxShadow: 'none',
    flexSrink: 0,
    position: 'relative',
  },

  [`& .${classes.flexGrow}`]: {
    flexGrow: 1,
  },

  [`& .${classes.topBarIcon}`]: {
    marginRight: '8px !important',
  },

  [`& .${classes.logo}`]: {
    zIndex: 5,
    '&:focus': {
      outline: '2px solid gray',
      outlineOffset: 5,
    },
  },
}));

const Topbar = props => {
  const { className, ...rest } = props;
  const theme = useTheme();

  const [notifications] = useState([]);
  const appContext = useContext(AppContext);

  const handleSignOut = event => {
    event.preventDefault();
    appContext.logout();
  };

  const rootUrl = `${window.location.protocol}//${window.location.host}/app/`;
  return (
    <StyledAppBar
      {...rest}
      style={{ background: appContext.session && appContext.session.superAdmin && '#702a2a' }}
      color={theme.appBarColor}
      className={clsx(classes.root, className)}
    >
      <Toolbar>
        <a href={rootUrl} className={classes.logo}>
          <img alt='Logo' src={theme.topLogo} width={theme.topLogoWidth || '100%'} />
        </a>

        <Time />
        <div className={classes.flexGrow} />

        <MeetupSelector />

        <Notifications />
        <GearMenu style={{ color: theme.palette[theme.appBarColor].contrastText }} />
        <RouterLink to='/profile/account' tabIndex={-1}>
          <IconButton
            className={classes.topBarIcon}
            style={{ color: theme.palette[theme.appBarColor].contrastText, marginRight: '8px' }}
            onClick={() => {}}
            data-test-id='top-profile'
            size='large'
          >
            <AccountCircle />
          </IconButton>
        </RouterLink>
        <IconButton
          className={classes.topBarIcon}
          style={{ color: theme.palette[theme.appBarColor].contrastText, marginRight: '8px' }}
          onClick={handleSignOut}
          data-test-id='top-logout'
          size='large'
        >
          <InputIcon />
        </IconButton>
      </Toolbar>
    </StyledAppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
};

export default Topbar;
